export class AccountOwner {
  id: string;
  name: string;
  email: string;
}
